import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';

import { useIframeHeight } from '../shared/hooks';
import { IOutput } from '../../../../shared/public/SlCodeEditorComponents/types/types';
import { IOutputType } from '../../../../api/public/code-api';
import { OutputIframeContainer } from '../Output/OutputIframeContainer';
import { OutputTextContainer } from '../Output/OutputTextContainer';

import s from './TIYWidgetOutput.scss';
import { OutputConsole } from '../Output/OutputConsole/OutputConsole';
import { lePlaygroundContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

interface TIYWidgetOutputProps {
	output: IOutput;
	isWeb: boolean;
}

const TIYWidgetOutput = ({ output, isWeb }: TIYWidgetOutputProps) => {
	const iframeHeight = useIframeHeight();
	useStyles(s);

	const outputRef = useRef(null);

	const { outputConsole$: outputConsole } = useContainerData(lePlaygroundContext.value, SlDataService, ['outputConsole$']);

	useEffect(() => {
		if (output) {
			setTimeout(() => {
				outputRef.current.scrollIntoView({ behavior: 'smooth' });
			}, 100);
		}
	}, [output]);

	const shouldIframeShow = (output?.outputType === IOutputType.html && iframeHeight > 0) || output?.outputType === IOutputType.raw;

	return (
		<div
			ref={outputRef}
			className={classNames('tiy-widfet-output', {
				show: (!!output && outputConsole) || shouldIframeShow,
			})}
		>
			{shouldIframeShow && (
				<div className="tiy-widfet-output__header">
					<span>{isWeb ? 'BROWSER' : 'OUTPUT'}</span>
				</div>
			)}
			{output?.outputType === IOutputType.raw ? (
				<OutputTextContainer value={output} isDarkMode={false} />
			) : (
				<OutputIframeContainer
					isTIYWidget
					value={output}
					isWeb={isWeb}
					iframeHeight={iframeHeight}
				/>
			)}
			{outputConsole && <OutputConsole isDarkMode={false} />}
		</div>
	);
};

export default TIYWidgetOutput;
